import React, { createContext, useContext, useMemo, useState } from 'react';

interface WalkthroughContextType {
  walkthroughComplete: boolean;
  setWalkthroughComplete: (complete: boolean) => void;
  setConnectStripeComplete: (complete: boolean) => void;
}

const WalkthroughContext = createContext<WalkthroughContextType | undefined>(undefined);

export const WalkthroughProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [walkthroughComplete, setWalkthroughComplete] = useState(false);
  const [stripeComplete, setConnectStripeComplete] = useState(false);

  const value: WalkthroughContextType = useMemo(
    () => ({
      walkthroughComplete,
      setWalkthroughComplete,
      setConnectStripeComplete,
    }),
    [walkthroughComplete, stripeComplete]
  );

  return (
    <WalkthroughContext.Provider value={value}>
      {children}
    </WalkthroughContext.Provider>
  );
};

export const useWalkthrough = (): WalkthroughContextType => {
  const context = useContext(WalkthroughContext);
  if (context === undefined) {
    throw new Error('useWalkthrough must be used within a WalkthroughProvider');
  }
  return context;
};

// Default export for compatibility
const WalkthroughManagerContext = {
  walkthroughComplete: false,
  setWalkthroughComplete: () => {},
  setConnectStripeComplete: () => {},
};

export default WalkthroughManagerContext;
